import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  selectedTool: null,
}

const toolsSlice = createSlice({
  name: 'toolsSlice',
  initialState,
  reducers: {
    setSelectedTool: (state, action) => {
      state.selectedTool = action.payload
    },
  },
})

export const { setSelectedTool } = toolsSlice.actions;

export const selectSelectedTool = state => state?.toolsSlice?.selectedTool;

export default toolsSlice.reducer;
